const BASE_URL = "/api/supplier-invoices";

export const fetchSupplierInvoices = async () => {
  const res = await fetch(BASE_URL, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) throw new Error("Error en la petición");
  return res.json();
};

export const fetchPurchaseInvoices = async (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  const res = await fetch(`/api/purchase-invoices?${qs.toString()}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) throw new Error("Error en la petición");
  return res.json();
};

export const fetchSupplierInvoiceByAccountMovement = async (
  accountMovementId
) => {
  const res = await fetch(`${BASE_URL}/by-movement/${accountMovementId}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    throw new Error("Error en la petición");
  }
  return res.json();
};

export const checkDuplicateSupplierInvoice = async ({
  supplierId,
  invoiceNumber,
  excludeInvoiceId = null,
  excludeMovementId = null,
} = {}) => {
  const params = new URLSearchParams({
    supplier_id: String(supplierId),
    invoice_number: String(invoiceNumber || ""),
  });
  if (excludeInvoiceId != null) {
    params.set("exclude_invoice_id", String(excludeInvoiceId));
  }
  if (excludeMovementId != null) {
    params.set("exclude_movement_id", String(excludeMovementId));
  }
  const res = await fetch(`${BASE_URL}/check-duplicate?${params}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) throw new Error("Error en la petición");
  return res.json();
};

export const createSupplierInvoice = async (body) => {
  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Error al crear la factura");
  }
  return res.json();
};

export const setSupplierInvoiceImage = async (id, imageKey) => {
  const res = await fetch(`${BASE_URL}/${id}/image`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ image_key: imageKey }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Error al asociar la imagen");
  }
  return res.json();
};

export const updateSupplierInvoice = async (body) => {
  const res = await fetch(`${BASE_URL}/${body.id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Error al actualizar la factura");
  }
  return res.json();
};

export const patchSupplierInvoiceDates = async (invoiceId, documentDate) => {
  const res = await fetch(`${BASE_URL}/${invoiceId}/dates`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ document_date: documentDate }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Error al actualizar la fecha del comprobante");
  }
  return res.json();
};
